import { render, staticRenderFns } from "./HomeContentLayout.vue?vue&type=template&id=d72cb5aa&scoped=true&"
import script from "./HomeContentLayout.vue?vue&type=script&lang=js&"
export * from "./HomeContentLayout.vue?vue&type=script&lang=js&"
import style0 from "./HomeContentLayout.vue?vue&type=style&index=0&id=d72cb5aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72cb5aa",
  null
  
)

export default component.exports